import React from "react"
import {SvgIcon, SvgIconProps} from "@mui/material"

export function PaymentPlanIcon(props: SvgIconProps) {
	return (
		<SvgIcon {...props} viewBox="0 0 20 20">
			<path
				d="M7.5 9.16667H5.83333V10.8333H7.5V9.16667ZM10.8333 9.16667H9.16667V10.8333H10.8333V9.16667ZM14.1667 9.16667H12.5V10.8333H14.1667V9.16667ZM15.8333 3.33333H15V1.66667H13.3333V3.33333H6.66667V1.66667H5V3.33333H4.16667C3.24167 3.33333 2.50833 4.08333 2.50833 5L2.5 16.6667C2.5 17.5833 3.24167 18.3333 4.16667 18.3333H15.8333C16.75 18.3333 17.5 17.5833 17.5 16.6667V5C17.5 4.08333 16.75 3.33333 15.8333 3.33333ZM15.8333 16.6667H4.16667V7.5H15.8333V16.6667Z"
				fill="currentColor"
			/>
		</SvgIcon>
	)
}
